// SPDX-License-Identifier: AGPL-3.0-or-later
import { ExtensionUrl, TranslationField, } from '@intakeform/fhir';
import {} from './languages.js';
/**
 * Read a translated value for (item, field, lang). Falls back to the
 * provided default when no matching translation extension is found.
 * The fallback is what guarantees the form never breaks on a missing
 * translation — patients always see *something*, even if it's
 * canonical English copy.
 */
export function translateField(item, field, lang, fallback) {
    if (lang === 'en')
        return fallback;
    const ext = findTranslationExt(item.extension, field, lang);
    if (ext === undefined)
        return fallback;
    const content = readSub(ext, TranslationField.content);
    return typeof content?.valueString === 'string' ? content.valueString : fallback;
}
/**
 * Read a translation for a single AnswerOption, keyed by the
 * `answerOption:<key>` field identifier. The `key` parameter is the
 * stable option key (matches the renderer's `answerOptionKey`).
 */
export function translateAnswerOption(item, optionKey, fallback, lang) {
    return translateField(item, `answerOption:${optionKey}`, lang, fallback);
}
// ---- internals -------------------------------------------------------------
function findTranslationExt(extensions, field, lang) {
    if (extensions === undefined)
        return undefined;
    for (const e of extensions) {
        if (e.url !== ExtensionUrl.translation)
            continue;
        const fieldSub = readSub(e, TranslationField.field);
        const langSub = readSub(e, TranslationField.lang);
        if (fieldSub?.valueCode !== field)
            continue;
        if (langSub?.valueCode !== lang)
            continue;
        return e;
    }
    return undefined;
}
function readSub(ext, url) {
    return ext.extension?.find((sub) => sub.url === url);
}
//# sourceMappingURL=translate.js.map